// import React, { useState } from "react";

// const BookingCarOne = () => {
//   const [pickup, setPickup] = useState("");
//   const [dropoff, setDropoff] = useState("");
//   const [carType, setCarType] = useState("");
//   const [date, setDate] = useState("");

//   // Prevent previous date selection
//   const today = new Date().toISOString().split("T")[0];

//   const handleWhatsAppBooking = (e) => {
//     e.preventDefault();

//     const message = `Hello Aaradhya Travels,

// I want to book a car.

// 🚖 Pickup City: ${pickup}
// 📍 Drop City: ${dropoff}
// 🚘 Car Type: ${carType}
// 📅 Travel Date: ${date}`;

//     const whatsappURL = `https://wa.me/919529697070?text=${encodeURIComponent(
//       message
//     )}`;

//     window.open(whatsappURL, "_blank");
//   };

//   return (
//     <section
//       className="booking-car-one bg-transparent wow fadeInUp"
//       data-wow-duration="1500ms"
//       data-wow-delay="500ms"
//     >
//       <div className="booking-car-one__inner">

//         {/* Background Image */}
//         <div
//           className="booking-car-one__bg"
//           style={{
//             backgroundImage:
//               "url(/images/backgrounds/car-bg.png)",
//           }}
//         ></div>

//         <div className="container">
//           <div className="row">
//             <div className="col-lg-6">

//               <div className="booking-car-one__content">
//                 <form
//                   onSubmit={handleWhatsAppBooking}
//                   className="booking-car-one__form"
//                 >

//                   {/* Top Content */}
//                   <div className="booking-car-one__form__top">
//                     <h4 className="booking-car-one__form__title">
//                       Book Your Ride
//                     </h4>

//                     <p className="booking-car-one__form__text">
//                       Aaradhya Travels – Safe, Comfortable & Reliable Travel Service
//                     </p>
//                   </div>

//                   {/* Form Grid */}
//                   <div className="booking-car-one__form__grid">

//                     {/* Pickup City */}
//                     <div className="booking-car-one__form__control">
//                       <label>
//                         <span className="icon-pin"></span> Pickup City
//                       </label>

//                       <input
//                         type="text"
//                         placeholder="Enter Pickup City"
//                         value={pickup}
//                         onChange={(e) => setPickup(e.target.value)}
//                         required
//                       />
//                     </div>

//                     {/* Drop City */}
//                     <div className="booking-car-one__form__control">
//                       <label>
//                         <span className="icon-pin"></span> Drop City
//                       </label>

//                       <input
//                         type="text"
//                         placeholder="Enter Drop City"
//                         value={dropoff}
//                         onChange={(e) => setDropoff(e.target.value)}
//                         required
//                       />
//                     </div>

//                     {/* Car Type */}
//                     <div className="booking-car-one__form__control">
//                       <label>
//                         <span className="icon-car"></span>
//                         Select Car Type
//                       </label>

//                       <select
//                         value={carType}
//                         onChange={(e) => setCarType(e.target.value)}
//                         required
//                         style={{
//                           width: "100%",
//                           height: "60px",
//                           border: "1px solid #dcdcdc",
//                           borderRadius: "8px",
//                           padding: "0 15px",
//                           background: "#fff",
//                           color: "#666",
//                           fontSize: "15px",
//                           outline: "none",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <option value="">Choose Car Type</option>
//                         <option value="Sedan">Sedan</option>
//                         <option value="SUV">SUV</option>
//                         <option value="Innova">Innova</option>
//                         <option value="Tempo Traveller">
//                           Tempo Traveller
//                         </option>
//                         <option value="Luxury Car">
//                           Luxury Car
//                         </option>
//                       </select>
//                     </div>

//                     {/* Date */}
//                     <div className="booking-car-one__form__control">
//                       <label>
//                         <span className="icon-calendar-1"></span>
//                         Select Travel Date
//                       </label>

//                       <input
//                         type="date"
//                         min={today}
//                         value={date}
//                         onChange={(e) => setDate(e.target.value)}
//                         required
//                         style={{
//                           width: "100%",
//                           height: "60px",
//                           border: "1px solid #dcdcdc",
//                           borderRadius: "8px",
//                           padding: "0 15px",
//                           background: "#fff",
//                           color: "#666",
//                           fontSize: "15px",
//                           outline: "none",
//                         }}
//                       />
//                     </div>

//                     {/* Button */}
//                     <div className="booking-car-one__form__control">
//                       <button
//                         type="submit"
//                         className="booking-car-one__btn"
//                         style={{
//                           width: "100%",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <span>Book Now</span>

//                       <span>
//   <i className="fa fa-arrow-right"></i>
// </span>
//                       </button>
//                     </div>

//                   </div>
//                 </form>
//               </div>

//             </div>
//           </div>

//           {/* Man Image */}
//           <div className="booking-car-one__man">
//             <img
//               src="/images/resources/man-1-1.png"
//               alt="Aaradhya Travels"
//             />
//           </div>

//           {/* Decorative Shape */}
//           <div className="booking-car-one__element">
//             <img
//               src="/images/shapes/details-shape.png"
//               alt="Shape"
//             />
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default BookingCarOne;











import React, { useState } from "react";

const BookingCarOne = () => {
  const [pickup, setPickup] = useState("");
  const [dropoff, setDropoff] = useState("");
  const [carType, setCarType] = useState("");
  const [date, setDate] = useState("");

  const today = new Date().toISOString().split("T")[0];

  const handleWhatsAppBooking = (e) => {
    e.preventDefault();

    const message = `Hello Aaradhya Travels,

I want to book a car.

🚖 Pickup City: ${pickup}
📍 Drop City: ${dropoff}
🚘 vehicle Type: ${carType}
📅 Travel Date: ${date}`;

    const whatsappURL = `https://wa.me/919529697070?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <section
      className="booking-car-one bg-transparent wow fadeInUp p-0"
      data-wow-duration="1500ms"
      data-wow-delay="500ms"
      style={{
        overflowX: "hidden",
        width: "100%",
      }}
    >
      <div className="booking-car-one__inner">
        {/* Background Image */}
        <div
          className="booking-car-one__bg"
          style={{
            backgroundImage: "url(/images/backgrounds/car-bg.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="booking-car-one__content">
                <form
                  onSubmit={handleWhatsAppBooking}
                  className="booking-car-one__form"
                >
                  <div className="booking-car-one__form__top">
                    <h4 className="booking-car-one__form__title">
                      Book Your VEHICLE
                    </h4>

                    <p className="booking-car-one__form__text">
                      Aaradhya Travels – Safe, Comfortable & Reliable Travel
                      Service
                    </p>
                  </div>

                  <div className="booking-car-one__form__grid">
                    {/* Pickup */}
                    <div className="booking-car-one__form__control">
                      <label>
                        <span className="icon-pin"></span> Pickup City
                      </label>

                      <input
                        type="text"
                        placeholder="Enter Pickup City"
                        value={pickup}
                        onChange={(e) => setPickup(e.target.value)}
                        required
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>

                    {/* Drop */}
                    <div className="booking-car-one__form__control">
                      <label>
                        <span className="icon-pin"></span> Drop City
                      </label>

                      <input
                        type="text"
                        placeholder="Enter Drop City"
                        value={dropoff}
                        onChange={(e) => setDropoff(e.target.value)}
                        required
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>

                    {/* Car Type */}
                    <div className="booking-car-one__form__control">
                      <label>
                        <span className="icon-car"></span>
                        Select vehicle
                      </label>

                      <select
                        value={carType}
                        onChange={(e) => setCarType(e.target.value)}
                        required
                        style={{
                          width: "100%",
                          height: "60px",
                          border: "1px solid #dcdcdc",
                          borderRadius: "8px",
                          padding: "0 15px",
                          background: "#fff",
                          color: "#666",
                          fontSize: "15px",
                          outline: "none",
                          cursor: "pointer",
                          boxSizing: "border-box",
                        }}
                      >
                        {/* <option value="">Choose Car Type</option>
                        <option value="Sedan">Sedan</option>
                        <option value="SUV">SUV</option>
                        <option value="Innova">Innova</option>
                        <option value="Tempo Traveller">Tempo Traveller</option>
                        <option value="Luxury Car">Luxury Car</option> */}


<option value="Tempo Traveller 9 Seater">Tempo Traveller 9 Seater</option>
<option value="Tempo Traveller 12 Seater">Tempo Traveller 12 Seater</option>
<option value="Tempo Traveller 14 Seater">Tempo Traveller 14 Seater</option>
<option value="Tempo Traveller 17 Seater">Tempo Traveller 17 Seater</option>
<option value="Tempo Traveller 20 Seater">Tempo Traveller 20 Seater</option>
<option value="Luxury Tempo Traveller">Luxury Tempo Traveller</option>

{/* Force Urbania */}
<option value="Force Urbania 10 Seater">Force Urbania 10 Seater</option>
<option value="Force Urbania 13 Seater">Force Urbania 13 Seater</option>
<option value="Force Urbania 17 Seater">Force Urbania 17 Seater</option>

{/* Mini Buses */}
<option value="Mini Bus 21 Seater">Mini Bus 21 Seater</option>
<option value="Mini Bus 25 Seater">Mini Bus 25 Seater</option>
<option value="Mini Bus 32 Seater">Mini Bus 32 Seater</option>

{/* Luxury Buses */}
<option value="Luxury Bus 35 Seater">Luxury Bus 35 Seater</option>
<option value="Luxury Bus 40 Seater">Luxury Bus 40 Seater</option>
<option value="Luxury Bus 45 Seater">Luxury Bus 45 Seater</option>
<option value="Luxury Bus 50 Seater">Luxury Bus 50 Seater</option>

{/* Cars */}
<option value="Sedan">Sedan</option>
<option value="SUV">SUV</option>
<option value="Innova Crysta">Innova Crysta</option>

                      </select>
                    </div>

                    {/* Date */}
                    <div className="booking-car-one__form__control">
                      <label>
                        <span className="icon-calendar-1"></span>
                        Select Travel Date
                      </label>

                      <input
                        type="date"
                        min={today}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                        style={{
                          width: "100%",
                          height: "60px",
                          border: "1px solid #dcdcdc",
                          borderRadius: "8px",
                          padding: "0 15px",
                          background: "#fff",
                          color: "#666",
                          fontSize: "15px",
                          outline: "none",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>

                    {/* Button */}
                    <div className="booking-car-one__form__control">
                      <button
                        type="submit"
                        className="booking-car-one__btn"
                        style={{
                          width: "100%",
                          border: "none",
                          cursor: "pointer",
                          boxSizing: "border-box",
                        }}
                      >
                        <span>Book Now</span>
                        <span>
                          <i className="fa fa-arrow-right"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Man Image */}
          <div
            className="booking-car-one__man"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src="/images/resources/man-1-1.png"
              alt="Aaradhya Travels"
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </div>

          {/* Decorative Shape */}
          <div
            className="booking-car-one__element"
            style={{
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src="/images/shapes/details-shape.png"
              alt="Shape"
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCarOne;